import { useState } from 'react';

export default function GallerySection() {
  const [selectedImage, setSelectedImage] = useState<string | null>(null);

  const galleryImages = [
    {
      id: 1,
      url: 'https://static.readdy.ai/image/4e6cb48aacd8b48acab6684eff653bcc/983b0a4848abd4d05fe26b9ca2e31074.jpeg',
      alt: 'Overhead 360 booth at wedding'
    },
    {
      id: 2,
      url: 'https://static.readdy.ai/image/4e6cb48aacd8b48acab6684eff653bcc/d7a69e7ff2f10fc6502cfeb1ae752bb6.jpeg',
      alt: 'Photo booth at corporate event'
    },
    {
      id: 3,
      url: 'https://static.readdy.ai/image/4e6cb48aacd8b48acab6684eff653bcc/d548d45f9c55784a5cf1e4205f5463b9.jpeg',
      alt: 'Birthday celebration with 360 booth'
    },
    {
      id: 4,
      url: 'https://static.readdy.ai/image/4e6cb48aacd8b48acab6684eff653bcc/86d89609f684aabf02ced1b9c1e5e2f7.jpeg',
      alt: 'Wedding couple at photo booth'
    },
    {
      id: 5,
      url: 'https://static.readdy.ai/image/4e6cb48aacd8b48acab6684eff653bcc/de39627772b4c7bcdc4ff0a39cedbace.jpeg',
      alt: 'Nighttime event with 360 booth'
    },
    {
      id: 6,
      url: 'https://static.readdy.ai/image/4e6cb48aacd8b48acab6684eff653bcc/7428adade2ae01f8149bf449d8d3b082.jpeg',
      alt: 'Corporate team building event'
    },
    {
      id: 7,
      url: 'https://static.readdy.ai/image/4e6cb48aacd8b48acab6684eff653bcc/62f6b3ff5cef60d1c47f0c40eed44de1.jpeg',
      alt: 'Quinceañera celebration'
    },
    {
      id: 8,
      url: 'https://static.readdy.ai/image/4e6cb48aacd8b48acab6684eff653bcc/df692d772cd03ed79a7281ce2af91db7.jpeg',
      alt: 'Gala event photo booth'
    }
  ];

  return (
    <>
      <section className="py-20 bg-white">
        <div className="max-w-7xl mx-auto px-6">
          <div className="text-center mb-16">
            <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-4">
              Moments We've Captured
            </h2>
            <p className="text-lg text-gray-600 max-w-2xl mx-auto">
              See our booths in action at weddings, corporate events, and celebrations across the region
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4">
            {galleryImages.map((image) => (
              <div
                key={image.id}
                className="relative overflow-hidden rounded-lg cursor-pointer group"
                onClick={() => setSelectedImage(image.url)}
              >
                <div className="w-full h-80">
                  <img
                    src={image.url}
                    alt={image.alt}
                    className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-110"
                  />
                </div>
                <div className="absolute inset-0 bg-black/0 group-hover:bg-black/40 transition-all duration-300 flex items-center justify-center">
                  <i className="ri-zoom-in-line text-white text-4xl opacity-0 group-hover:opacity-100 transition-opacity duration-300"></i>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Lightbox Modal */}
      {selectedImage && (
        <div
          className="fixed inset-0 bg-black/90 z-50 flex items-center justify-center p-4"
          onClick={() => setSelectedImage(null)}
        >
          <button
            className="absolute top-6 right-6 w-12 h-12 flex items-center justify-center text-white hover:bg-white/10 rounded-full transition-colors cursor-pointer"
            onClick={() => setSelectedImage(null)}
          >
            <i className="ri-close-line text-3xl"></i>
          </button>
          <div className="max-w-6xl w-full h-full flex items-center justify-center">
            <img
              src={selectedImage}
              alt="Gallery image"
              className="max-w-full max-h-full object-contain"
              onClick={(e) => e.stopPropagation()}
            />
          </div>
        </div>
      )}
    </>
  );
}
